/** ===================================================================
 *  Bestdealdepot: centerModal.js v1.1.0
 *  Extend: bootstrap modal.js
 *  
 *  Show the modal at the center of viewport
 *  ===================================================================
 */
+function($, window, document) {
	//constructor
	var CenterModal = function(element, options) {
		this.options        = options
	    this.$body          = $(document.body)
	    this.$element       = $(element)
	    this.$backdrop      =
	    this.isShown        = null
	    this.scrollbarWidth = 0

	    if (this.options.remote) {
	      this.$element
	        .find('.modal-body')
	        .load(this.options.remote, $.proxy(function () {
	          this.$element.trigger('loaded.bs.modal');
	        }, this));
	    }
	};
	
	//static
	CenterModal.VERSION  = '3.3.0';

	CenterModal.TRANSITION_DURATION = 300;
	CenterModal.BACKDROP_TRANSITION_DURATION = 150;

	CenterModal.DEFAULTS = {
		backdrop: true,
	    keyboard: true,
	    show: true
	};
	
	//public methods
	CenterModal.prototype = $.extend({}, $.fn.modal.Constructor.prototype);
	
	CenterModal.prototype.show = function (_relatedTarget) {
		$.fn.modal.Constructor.prototype.show.call(this, _relatedTarget);
		
		this.center();
	};
	
	//display modal at center of viewport
	CenterModal.prototype.center = function() {
		var modalBody,
			modalDialog,
			modalHeight,
			winHeight,
			modalMarginTop = 100;
		
		modalBody = this.$element.find('.modal-body');
		modalDialog = this.$element.find('.modal-dialog');
		modalHeight = modalDialog.height();
		winHeight = $(window).height();
		
		if (winHeight > modalHeight) {
			modalMarginTop = (winHeight - modalHeight) / 2;
		}
		
		modalDialog.css({
			'margin-top': modalMarginTop
		});
	};
	
	// PLUGIN DEFINITION
	function Plugin(option, _relatedTarget) {
	    return this.each(function () {
	      var $this   = $(this);
	      var data    = $this.data('bs.modal');
	      var options = $.extend({}, CenterModal.DEFAULTS, $this.data(), typeof option == 'object' && option);
	
	      if (!data) $this.data('bs.modal', (data = new CenterModal(this, options)));
	      if (typeof option == 'string') data[option](_relatedTarget);
	      else if (options.show) data.show(_relatedTarget);
	    });
	}

	var old = $.fn.centerModal;

	$.fn.centerModal             = Plugin;
	$.fn.centerModal.Constructor = CenterModal;
	
	//NO CONFLICT
	$.fn.modal.noConflict = function () {
		$.fn.centerModal = old;
		return this;
	};
	
	//data-api
	$(document).on('click.bs.modal.data-api', '[data-toggle="center-modal"]', function (e) {
	    var $this   = $(this);
	    var href    = $this.attr('href');
	    var $target = $($this.attr('data-target') || (href && href.replace(/.*(?=#[^\s]+$)/, ''))); // strip for ie7
	    var option  = $target.data('bs.modal') ? 'toggle' : $.extend({ remote: !/#/.test(href) && href }, $target.data(), $this.data());

	    if ($this.is('a')) e.preventDefault();

	    $target.one('show.bs.modal', function (showEvent) {
	      if (showEvent.isDefaultPrevented()) return; // only register focus restorer if modal will actually get shown
	      
	      $target.one('hidden.bs.modal', function () {
	        $this.is(':visible') && $this.trigger('focus');
	      });
	    });
	    
	    Plugin.call($target, option, this);
	});
}(jQuery, window, document);